import Vue from 'vue';
import Router from 'vue-router';

import Pins from '@/components/pin/pins';
import Pin from '@/components/pin/pin';

import store from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/Pins',
      name: 'Pins',
      component: Pins,
      meta: {
        roles: ['admin', 'developer'],
      },
    },
    {
      path: '/Pins/:pinRef',
      name: 'Pin',
      component: Pin,
      props: true,
      meta: {
        roles: ['admin', 'developer'],
      },
    },
    {
      path: '*',
      redirect: '/Pins',
    },
  ],
});

const isFirstRoute = from => from.name === null;
const userInRoles = roles => store.getters['Acacia/Profile/inRoles'](roles);

router.beforeEach((to, from, next) => {
  store.getters['Acacia/loaded'].then(() => {
    if (!isFirstRoute(from) && !to.matched.some(record => record.meta.roles)) next();
    else if (userInRoles(to.meta.roles)) next();
    else if (userInRoles(['admin', 'developer'])) next({ name: 'Pins' });
    else next({ name: 'Pins', query: { redirect: to.fullPath } });
  });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js